import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PlatformModule } from '@app/platform.module';
import { AppCommonModule } from '@common/common.module';
import { Components, TimeClockComponent } from '@dashboard/components';
/* Common Modules */
import { DashboardRouterModule } from '@dashboard/dashboard.routes';
/* Common Views */
import { DashboardView } from '@dashboard/views/dashboard/dashboard.view';
/* Forms */
import { ChipFilterList } from '@app/components/chip-filters/chip-filters-list.component';
import { DashboardTasksService } from '@app/modules/dashboard/services/dashboard-tasks.service';
import { EventService } from '@dashboard/services/event.service';
import { EmployeesCommonModule } from '@employees/employees.common.module';
import { CompanyFormsModule } from '@forms/company/company-forms.module';
import { DashboardFormsModule } from '@forms/dashboard/dashboard-forms.module';
import { CompanyAnnouncementStoreView } from './views/company-announcement/store/company-announcement-store.view';

@NgModule({
    imports: [
        DashboardRouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppCommonModule,
        PlatformModule,
        EmployeesCommonModule,
        CompanyFormsModule,
        DashboardFormsModule,
        ChipFilterList,
        TimeClockComponent,
    ],
    providers: [DashboardTasksService, EventService],
    declarations: [DashboardView, CompanyAnnouncementStoreView, ...Components],
    exports: [...Components],
})
export class DashboardModule {}
